/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';

interface SettingsConfirmDeleteFormArgs {
  inputLabel: string;
  submitLabel: string;
  comparisonValue?: string;

  onCancel: () => unknown;
  onSubmit: (evt: Event) => Promise<void>;
}

export default class SettingsConfirmDeleteForm extends Component<SettingsConfirmDeleteFormArgs> {
  @tracked name = '';

  get isValid() {
    return this.name === this.args.comparisonValue;
  }

  get submitDisabled() {
    return !this.isValid || this.submitTask.isRunning;
  }

  submitTask = task(async (evt: Event) => {
    evt.preventDefault();
    await this.args.onSubmit(evt);
  });
}
